var _style, _rect, _line, _rect2, _clipPath, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseScaleScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes scrollDot {\n      0%, 5% { transform: translateY(0); opacity: 0; }\n      10% { transform: translateY(0); opacity: 1; }\n      25% { transform: translateY(-10px); opacity: 1; }\n      30% { transform: translateY(-10px); opacity: 1; }\n      55% { transform: translateY(10px); opacity: 1; }\n      60% { transform: translateY(10px); opacity: 1; }\n      80% { transform: translateY(-10px); opacity: 1; }\n      90% { transform: translateY(0px); opacity: 1; }\n      95%, 100% { transform: translateY(0); opacity: 0; }\n    }\n    .sd { animation: scrollDot 3.5s ease-in-out infinite; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 52,
    width: 84,
    height: 136,
    rx: 42,
    ry: 42,
    fill: "#888",
    stroke: "#999 ",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 52,
    x2: 120,
    y2: 108,
    stroke: "#888",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 78,
    width: 16,
    height: 36,
    rx: 8,
    fill: "#bbb"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "wheelClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 78,
    width: 16,
    height: 36,
    rx: 8
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "sd",
    cx: 120,
    cy: 96,
    r: 8,
    fill: "#444",
    clipPath: "url(#wheelClip)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseScaleScroll);
export default __webpack_public_path__ + "static/media/mouse-scale-scroll.bd32866aef2f5fce6dfe263e1937744a.svg";
export { ForwardRef as ReactComponent };